var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"v-tag",class:{ active: _vm.selected },attrs:{"type":"button"}},[_vm._v(" "+_vm._s(_vm.label)+" "),(_vm.count)?_c('div',{staticClass:"v-tag__counter"},[_vm._v(_vm._s(_vm.count))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }